/** Visible dock tooltip text. The icon is keyed by kind; these short hints
 * explain the action even when a human-authored ability name changes. */
import type { AbilityKind } from "@pd/shared";

const HINTS: Record<AbilityKind, string> = {
  "next-hit-bonus": "Put extra force behind your next weapon hit.",
  "next-hit-reduce": "Reserved ability; not implemented yet.",
  "next-hit-splash": "Make your next hit splash onto nearby enemies.",
  "damage-immune": "Let incoming blows pass harmlessly for a moment.",
  "damage-reflect": "Absorb half of each hit and return that damage to its attacker.",
  "pull-vortex": "Drop a vortex on a tile to hurt and pull nearby enemies.",
  "next-hit-chain": "Send your next hit through nearby enemies.",
  "room-aoe": "Hit every enemy in your room at once.",
  "speed-buff": "Put some speed in your step for a short while.",
  teleport: "Pick a tile in this room and blink there.",
  telegrab: "Pick an item in this room and pull it to you.",
  "phoenix-teleport": "Burn back to the tile where you last died on this floor.",
};

export function abilityHint(kind: AbilityKind): string {
  return HINTS[kind];
}

export function createAbilityTooltip(): HTMLDivElement {
  const tip = document.createElement("div");
  tip.className = "ability-tooltip";
  tip.setAttribute("role", "tooltip");
  const name = document.createElement("strong");
  name.className = "ability-tooltip-name";
  const detail = document.createElement("span");
  detail.className = "ability-tooltip-detail";
  const state = document.createElement("span");
  state.className = "ability-tooltip-state";
  tip.append(name, detail, state);
  return tip;
}

export function updateAbilityTooltip(tip: HTMLElement, name: string, detail: string, state = ""): void {
  (tip.querySelector(".ability-tooltip-name") as HTMLElement).textContent = name;
  (tip.querySelector(".ability-tooltip-detail") as HTMLElement).textContent = detail;
  (tip.querySelector(".ability-tooltip-state") as HTMLElement).textContent = state;
}
